import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import {
  Stack,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
  Avatar,
  Grid,
  Tooltip,
  useMediaQuery,
  Popover,
} from "@mui/material";
import { COLORS } from "colors/color";
import { styled, useTheme } from "@mui/material/styles";
import { List, ListItem } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { TiPlus } from "react-icons/ti";
import { GoPlus } from "react-icons/go";

import { useNavigate } from "react-router-dom";
import { TitleTypography } from "StyledTypography/StyledTypography";
import {
  DatePicker,
  LocalizationProvider,
  StaticDatePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import CalendarComponent from "./TootlBar";
import { useTranslation } from "react-i18next";
import colors from "colors/color";
import GoogleCalendar from "./googleCalendar";
import blank_calendar from "../../assets/img/blank-calendar.svg";
function formatDate(dateString) {
  const options = { year: "numeric", month: "short", day: "numeric" };
  return new Date(dateString).toLocaleDateString(undefined, options);
}

const Calendar = () => {
  const [eventGuid, setEventGuid] = useState(0);
  const [weekendsVisible, setWeekendsVisible] = useState(true);
  const [currentEvents, setCurrentEvents] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [candidate, setCandidate] = useState("");
  const [data, setData] = useState([]);
  const [openDelete, setOpenDelete] = useState("");
  const [formData, setFormData] = useState({
    candidate: "",
    event_title: "",
    event_start_date: "",
    event_end_date: "",
  });
  const apiUrl = process.env.REACT_APP_API_URL;
  const userId = getUserIdFromAccessToken();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const {t}=useTranslation();
  const navigate = useNavigate();
  const fetchEventsByRecruiter = useCallback(async () => {
    if (!userId) return;
    try {
      const response = await axios.get(
        `${apiUrl}authentication/events/${userId}/`
      );
      const events = response.data
        .map((event) => ({
          id: event.id,
          title:
            event.event_title.charAt(0).toUpperCase() +
            event.event_title.slice(1),
          start: event.event_start_date,
          end: event.event_end_date,
          extendedProps: {
            candidate: {
              full_name: `${
                event.candidate.first_name.charAt(0).toUpperCase() +
                event.candidate.first_name.slice(1)
              }
                 ${
                   event.candidate.last_name.charAt(0).toUpperCase() +
                   event.candidate.last_name.slice(1)
                 }`,
              candidate_id: event.candidate.id,
              candidate_image: event.candidate.image,
            },
          },
        }))
        .sort((a, b) => new Date(a.start) - new Date(b.start));

      if (JSON.stringify(events) !== JSON.stringify(currentEvents)) {
        setCurrentEvents(events);
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  }, [userId, apiUrl, currentEvents]);

  useEffect(() => {
    fetchEventsByRecruiter();
  }, [fetchEventsByRecruiter]);

  function getUserIdFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token found in local storage");
      return null;
    }

    try {
      const decodedToken = parseJwt(accessToken);
      return decodedToken.user_id;
    } catch (error) {
      console.error("Failed to decode access token", error);
      return null;
    }
  }

  function parseJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  }

  const createEventId = useCallback(() => {
    const newId = eventGuid + 1;
    setEventGuid(newId);
    return String(newId);
  }, [eventGuid]);

  const [selectInfo, setSelectInfo] = useState(null);

  const handleDateSelect = (date) => {
    if (date && calendarRef.current) {
      const calendar = calendarRef.current.getApi();
      calendar.gotoDate(date.toDate());
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDialogSubmit = async () => {
    console.log("candidate id is :", candidate);
    setFormData({
      candidate: candidate,
      event_title: title,
      event_start_date: selectInfo.startStr,
      event_end_date: selectInfo.endStr,
    });

    try {
      const response = await fetch(`${apiUrl}authentication/events/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        console.log("Data posted successfully!");
        const calendarApi = selectInfo.view.calendar;
        calendarApi.unselect();
        calendarApi.addEvent({
          id: createEventId(),
          title: title,
          candidate: candidate,
          start: selectInfo.startStr,
          end: selectInfo.endStr,
          allDay: selectInfo.allDay,
          extendedProps: {
            candidate: {
              full_name: candidate,
            },
          },
        });
        setDialogOpen(false);
        setTitle("");
        setCandidate("");
        fetchEventsByRecruiter(); // Refresh events after adding new one
      } else {
        console.error("Failed to post data:", response.statusText);
      }
    } catch (error) {
      console.error("Failed to post data:", error.message);
    }
  };

  const deleteInfo = async (eventId) => {
    try {
      await axios.delete(`${apiUrl}authentication/events/delete/${eventId}/`);
      console.log(`Event with ID ${eventId} deleted successfully`);
    } catch (error) {
      console.error(
        `Error deleting event with ID ${eventId}: ${error.message}`
      );
    }
  };

  const [info, setInfo] = useState("");
  const handleEventClick = (clickInfo) => {
    setInfo(clickInfo);
    console.log("clickInfo", clickInfo);
    // setOpenDelete(true);
  };

  const handleSelectChangeCandidate = (event) => {
    setCandidate(event.target.value);
  };
  const cutText = (text, length) => {
    // Check if the text exists and is a string
    if (text && typeof text === "string") {
      // If the text length is greater than the specified length, cut it
      if (text.length > length) {
        return `${text.substr(0, length)}...`;
      }
    }
    // Return the original text if it's shorter or if it doesn't exist
    return text || "";
  };

  const EventItem = styled("li")(({ theme, eventColor }) => ({
    marginBottom: "13px",
    // background: `linear-gradient(135deg, ${eventColor} 0%, ${eventColor}88 100%)`,
    borderRadius: "17px",
    padding: "16px",
    position: "relative",
    overflow: "hidden",
    boxShadow: "none",
    border: '1px solid #D9D9D9',
    "&::-webkit-scrollbar": {
      width: "6px",
      display: "none",
    },
    "&:hover": {
      "&::-webkit-scrollbar": {
        display: "block",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: "transparent",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "linear-gradient(45deg, #0085FF, #004F98)",
        borderRadius: "4px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "linear-gradient(45deg, #004F98, #002B5C)",
      },
    },
    // transition: "transform 0.3s ease, box-shadow 0.3s ease",
    // display:"flex",
    // alignItems: "space-between",
    // justifyContent: "center",
    // "&:hover": {
    //   transform: "translateY(-5px)",
    //   boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
    // },
  }));

  const renderSidebarEvent = (event) => {
    const handleSendMessage = () => {
      console.log("Send message for event:", event);
      navigate("/talent/Chat/", {
        state: { candidate: event.extendedProps?.candidate },
      });
    };

    const getDateDifference = (startDate) => {
      const currentDate = new Date();
      const eventStartDate = new Date(startDate);
      const differenceInTime = eventStartDate - currentDate;
      const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
      return differenceInDays;
    };

    const getTitleColor = (days) => {
      if (days > 7) return "#34A853";
      if (days > 3) return "#FFA800";
      return "#FF0000";
    };

    const differenceInDays = getDateDifference(event.start);
    const titleColor = getTitleColor(differenceInDays);

    const candidate = event.extendedProps?.candidate;
    const candidateName = candidate?.full_name || "No name available";
    const candidateImage = candidate?.candidate_image;
    return  (
      <EventItem
        key={event.id}
        onClick={handleSendMessage}
        style={{ cursor: "pointer" }}
        sx={{ backgroundColor: "#fff",
          // mt: 1,
         }}
      >
        <Grid container spacing={1} alignItems="center">
          {/* Tooltip with Paper */}
          <Grid item xs={5}>
            <Tooltip
              title={event.title}
              arrow
              placement="top-start"
              followCursor
            >
              <Paper
                sx={{
                  height: 45,
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "none",
                  borderRadius: 2,
                  padding: 2,
                  border: '1px solid #D9D9D9',
                }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    fontFamily: "Poppins",
                    textTransform: "none",
                    color: titleColor,
                    fontWeight: 500,
                  }}
                >
                  {cutText(event.title, 15)}
                </Typography>
              </Paper>
            </Tooltip>
          </Grid>

          {/* avatar */}
          <Grid item xs={2}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Avatar
                sx={{
                  bgcolor: candidateImage ? "#ffffff" : colors.primary,
                  width: 40,
                  height: 40,
                  border: "1px solid #ccc",
                  color: candidateImage ? "inherit" : "#ffffff"
                }}
                src={candidateImage}
              >
                {candidateImage ? (
                  <img src={candidateImage} alt="Candidate" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                ) : (
                  candidateName.charAt(0).toUpperCase()
                )}
              </Avatar>
            </Box>
          </Grid>

          {/*  name... */}
          <Grid item xs={5}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: 12,
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                    textTransform: "none",
                    color: colors.primary,
                  }}
                >
                  {candidateName}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: 8,
                    fontFamily: "Poppins",
                    textTransform: "none",
                    color: COLORS.secondary,
                  }}
                >
                  {formatDate(event.start)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {/*Button */}
          {/* <Grid item xs={2}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                sx={{
                  backgroundColor: COLORS.button_color,
                  height: 30,
                  width: 30,
                  borderRadius: 2,
                  minWidth: 0,
                  "& svg": {
                    color: "white",
                    fontSize: 20,
                  },
                }}
              >
                <GoPlus />
              </Button>
            </Box>
          </Grid> */}
        </Grid>
      </EventItem>
    
    );
  };

   const renderEventContent = (event) => {
    const handleSendMessage = () => {
      console.log("Send message for event:", event);
      navigate("/talent/Chat/", {
        state: { candidate: event.extendedProps?.candidate },
      });
    };

    const getDateDifference = (startDate) => {
      const currentDate = new Date();
      const eventStartDate = new Date(startDate);
      const differenceInTime = eventStartDate - currentDate;
      const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
      return differenceInDays;
    };

    const getTitleColor = (days) => {
      if (days > 7) return "#34A853";
      if (days > 3) return "#FFA800";
      return "#FF0000";
    };

    const differenceInDays = getDateDifference(event.start);
    const titleColor = getTitleColor(differenceInDays);

    const candidate = event.extendedProps?.candidate;
    const candidateName = candidate?.full_name || "No name available";
    const candidateImage = candidate?.candidate_image;
    return !isMobile ? (
      <EventItem
        key={event.id}
        onClick={handleSendMessage}
        style={{ cursor: "pointer" }}
        sx={{ backgroundColor: "#fff" }}
      >
        <Grid container spacing={1} alignItems="center">
          {/* Tooltip with Paper */}
          <Grid item xs={4}>
            <Tooltip
              title={event.title}
              arrow
              placement="top-start"
              followCursor
            >
              <Paper
                sx={{
                  height: 45,
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "none",
                  borderRadius: 2,
                  padding: 2,
                  border: '1px solid #D9D9D9',
                }}
              >
                <Typography
                  sx={{
                    fontSize: 12,
                    fontFamily: "Poppins",
                    textTransform: "none",
                    color: titleColor,
                    fontWeight: 500,
                  }}
                >
                  {cutText(event.title, 15)}
                </Typography>
              </Paper>
            </Tooltip>
          </Grid>

          {/* avatar */}
          <Grid item xs={2}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Avatar
                sx={{
                  bgcolor: "#ffffff",
                  width: 40,
                  height: 40,
                  border: "1px solid #ccc",
                }}
                src={candidateImage}
              >
                {candidateName.charAt(0).toUpperCase()}
              </Avatar>
            </Box>
          </Grid>

          {/*  name... */}
          <Grid item xs={4}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: 12,
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                    textTransform: "none",
                    color: colors.primary,
                  }}
                >
                  {candidateName}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: 8,
                    fontFamily: "Poppins",
                    textTransform: "none",
                    color: colors.primary,
                  }}
                >
                  {formatDate(event.start)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </EventItem>
    ) : (
      <EventItem
        key={event.id}
        onClick={handleSendMessage}
        style={{ cursor: "pointer" }}
        sx={{ backgroundColor: "#fff" }}
      >
        <Grid container spacing={1} alignItems="center">
          

          {/*  name... */}
          <Grid item xs={8}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: 12,
                    fontFamily: "Poppins",
                    fontWeight: "bold",
                    textTransform: "none",
                    color: colors.primary,
                  }}
                >
                  {candidateName}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: 8,
                    fontFamily: "Poppins",
                    textTransform: "none",
                    color: colors.primary,
                  }}
                >
                  {formatDate(event.start)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {/*Button */}
          <Grid item xs={4}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                sx={{
                  backgroundColor: colors.primary,
                  height: 30,
                  width: 30,
                  borderRadius: 2,
                  minWidth: 0,
                  "& svg": {
                    color: "#ffffff",
                    fontSize: 20,
                  },
                }}
              >
                <GoPlus />
              </Button>
            </Box>
          </Grid>
        </Grid>
      </EventItem>
    );
  };
  const ModernPaper = styled(Paper)(({ theme, isMobile }) => ({
    width: isMobile ? "155px" : "350px",
    overflowY: "auto",
    padding: "12px",
    backgroundColor: "#F4F5F7",
  }));

  const EventList = styled(List)({
    padding: 0,
  });

  // Styled component for the empty state
  const EmptyStateContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    textAlign: "center",
    padding: theme.spacing(3),
  }));

  const EmptyStateText = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(2),
    color: COLORS.secondary,
    fontSize: "1rem",
    fontFamily: "Poppins",
  }));

  const CalendarContainer = styled("div")({
    flexGrow: 1,
    height: "100%",
    width: "100%",
    minWidth: 0, // Allow shrinking
    // backgroundColor:'#fff',
    "& .fc": {
      fontFamily: "Arial, sans-serif",
      width: "100%",
      height: "100%",
      "& .fc-toolbar-title": {
        fontSize: "1.5rem",
        fontWeight: "bold",
      },
      "& .fc-button": {
        backgroundColor: COLORS.signIn,
        borderColor: COLORS.signIn,
        "&:hover": {
          backgroundColor: COLORS.white,
          borderColor: COLORS.signIn,
          color: COLORS.signIn,
        },
      },
      "& .fc-day-today": {
        backgroundColor: "rgba(74, 144, 226, 0.1) !important",
      },
      "& .fc-event": {
        backgroundColor: "transparent",
        borderColor: "transparent",
        borderRadius: "4px",
      },
    },
  });

  const calendarRef = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleDatePickerClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDateChange = (date) => {
    if (date && calendarRef.current) {
      const calendar = calendarRef.current.getApi();
      calendar.gotoDate(date);
      setSelectedDate(date);
      setAnchorEl(null);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div className="content">
      <Stack
        direction="row"
        spacing={3}
        sx={{
          height: "calc(100vh - 20px)",
          width: "100%",
          p: 0,
          marginTop: "20px",
          marginRight: "20px",
          overflow: "hidden", // Prevent overflow issues
        }}
      >
        {!isMobile ? (
          <ModernPaper elevation={0} isMobile={isMobile}>
            {currentEvents.length > 0 ? (
              <EventList>
                {currentEvents.map((event) => renderSidebarEvent(event))}
              </EventList>
            ) : (
              <EmptyStateContainer>
                <img src={ blank_calendar} alt="Blank Calendar" />
                
                {/* <CalendarMonthIcon sx={{ fontSize: 48, color: COLORS.secondary }} /> */}
                <EmptyStateText>
                  {t('calendar.No events scheduled yet')}
                </EmptyStateText>
              </EmptyStateContainer>
            )}
          </ModernPaper>
        ) : (
          ""
        )}
        {/* <Box sx={{
            marginTop:4,
            paddingTop:4,
            width:'100%'
          }}> */}
        <CalendarContainer>
          <CalendarComponent
            weekendsVisible={weekendsVisible}
            renderEventContent={renderEventContent}
            handleEventClick={handleEventClick}
            currentEvents={currentEvents}
          />
        </CalendarContainer>
        {/* </Box> */}

        {/* <GoogleCalendar 
        weekendsVisible={weekendsVisible}
        renderEventContent={renderEventContent}
        handleEventClick={handleEventClick}
        currentEvents={currentEvents}
        /> */}
        <Dialog open={dialogOpen} onClose={handleDialogClose}>
          <DialogTitle>Add New Event</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Event Title"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <FormControl fullWidth margin="dense">
              <InputLabel id="candidate-label">Candidate's Name</InputLabel>
              <Select
                labelId="candidate-label"
                id="candidate"
                value={candidate}
                onChange={handleSelectChangeCandidate}
              >
                {data.map((candidate) => (
                  <MenuItem key={candidate.id} value={candidate.id}>
                    {`${candidate.first_name} ${candidate.last_name}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose}>Cancel</Button>
            <Button onClick={handleDialogSubmit} color="primary">
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </Stack>

      <Dialog
        open={openDelete}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          style: {
            borderRadius: "8px",
            padding: "24px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <DialogContent>
          <Typography
            fontSize={28}
            fontWeight="bold"
            fontFamily="sans-serif"
            color={COLORS.signIn}
            gutterBottom
          >
            Confirm Deletion
          </Typography>
          <Typography
            fontSize={18}
            fontFamily="sans-serif"
            color={COLORS.grey}
            paragraph
          >
            Are you sure you want to delete this event?
          </Typography>
          <Typography
            fontSize={14}
            fontFamily="sans-serif"
            color={COLORS.signIn}
            paragraph
          >
            This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end", mt: 2 }}>
          <Button
            variant="contained"
            onClick={() => setOpenDelete(false)}
            sx={{
              height: "100%",
              color: COLORS.signIn,
              border: "1px solid",
              borderColor: COLORS.grey,
              bgcolor: COLORS.white,
              ":hover": {
                bgcolor: COLORS.Button_OnHold,
                borderColor: COLORS.signIn,
                color: COLORS.signIn,
              },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              deleteInfo(info.event.id);
              info.event.remove();
              fetchEventsByRecruiter();
              setOpenDelete(false);
            }}
            sx={{
              height: "100%",
              color: COLORS.white,
              border: "1px solid",
              borderColor: COLORS.grey,
              bgcolor: COLORS.signIn,
              ":hover": {
                bgcolor: COLORS.Button_OnHold,
                borderColor: COLORS.signIn,
                color: COLORS.signIn,
              },
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Calendar;
 